module.exports = __webpack_public_path__ + "img/teacher-t2.cceafc01.png";